import { initializeApp, FirebaseApp } from 'firebase/app'
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence, Auth } from 'firebase/auth'

const apiKey     = import.meta.env['VITE_FIREBASE_API_KEY']
const authDomain = import.meta.env['VITE_FIREBASE_AUTH_DOMAIN']
const projectId  = import.meta.env['VITE_FIREBASE_PROJECT_ID']

let _app:  FirebaseApp | null = null
let _auth: Auth | null = null

if (apiKey && authDomain && projectId) {
  _app  = initializeApp({ apiKey, authDomain, projectId })
  // Use initializeAuth WITHOUT a popupRedirectResolver so Firebase doesn't load
  // its cross-domain auth helper iframe (__/auth/iframe.js, ~92 KiB, ~1.8s) on
  // every page. We sign in with custom tokens; Google popup sign-in passes the
  // resolver on-demand (see useAuth), so the iframe only loads if it's used.
  _auth = initializeAuth(_app, {
    persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  })
}

export const auth = _auth
export const isFirebaseAvailable = !!_app
